import React from 'react';
import '../styles/abudhabi.css';
import logo from "../assets/logo3.webp";
import { Link, useLocation } from "react-router-dom";
import abuDhabiData from '../data/abudhabi.json';
import abuDhabiBanner from '../assets/abudhabi.webp';

const imageMap = {
      '../assets/sheikh.png': require('../assets/sheikh.png'),
    '../assets/louvre.png': require('../assets/louvre.png'),
    '../assets/qasr.png': require('../assets/qasr.png'),
    '../assets/cofniche.png': require('../assets/cofniche.png'),
    '../assets/mangrove.png': require('../assets/mangrove.png'),
    '../assets/ferrari.png': require('../assets/ferrari.png'),
    '../assets/warner.png': require('../assets/warner.png'),
    '../assets/yas.png': require('../assets/yas.png'),
    '../assets/emirates.png': require('../assets/emirates.png'),
    '../assets/wabu.png': require('../assets/wabu.png'),
    '../assets/streggis.png': require('../assets/streggis.png'),
    '../assets/rosewood.png': require('../assets/rosewood.png'),
    '../assets/qasral.png': require('../assets/qasral.png'),
    '../assets/heritagevillage.png': require('../assets/heritagevillage.png'),
    '../assets/falcon.png': require('../assets/falcon.png'),
    '../assets/camelracing.png': require('../assets/camelracing.png')

};

const AbuDhabi = () => {
  const location = useLocation();
  return (
    <>
      {/* Header Section */}
      <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="Tourly Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/">Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
            <a href="#" className={`contact-dropbtn ${location.pathname === '/abu' ? 'active-link' : ''}`}>Destinations</a>
            <div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
              <Link to="/abu">Abu Dhabi</Link>
              <Link to="/dubai">Dubai</Link>
            </div>
          </div>
          <Link to="/hotels">Hotels</Link>
          <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'active-link' : ''}>Contact Us</Link>
        </nav>
        <Link to="/booknow">
          <button className="contact-book-btn">Book Now</button>
        </Link>
      </header>

      <div className="AbuDhabi-page">
        <div className="AbuDhabi-hero">
          <div className="AbuDhabi-hero-overlay">
            <h1>Explore Abu Dhabi</h1>
            <p>Culture, Adventure, and Grandeur – The Capital of the UAE</p>
          </div>
          <img src={abuDhabiBanner} alt="Abu Dhabi Banner" className="AbuDhabi-hero-img" />
        </div>

        <section className="AbuDhabi-info">
          <h2>Welcome to Abu Dhabi</h2>
          <p>
            Abu Dhabi is a blend of rich heritage and modern luxury. From the breathtaking beauty of the Sheikh Zayed Grand Mosque to the thrilling rides at Ferrari World and the cultural depths of the Louvre, this city offers a sophisticated and diverse experience.
          </p>
        </section>

        {Object.entries(abuDhabiData).map(([sectionTitle, items]) => (
          <section className="AbuDhabi-section" key={sectionTitle}>
            <h2>{formatTitle(sectionTitle)}</h2>
            <div className="AbuDhabi-cards-container">
              {items.map((item, index) => (
                <div className="AbuDhabi-card" key={index}>
                  <img
                    src={imageMap[item.image] || item.image}
                    alt={item.name}
                  />
                  <h3>{item.name}</h3>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

const formatTitle = (key) => {
  switch (key) {
    case 'Attractions': return 'Top Attractions';
    case 'ThemeParks': return 'Thrilling Theme Parks';
    case 'CulturalSites': return 'Cultural Sites';
    case 'Activities': return 'Must-Do Activities';
    default: return key;
  }
};

export default AbuDhabi;